export default "__VITE_ASSET__1sVZRKwh__"